import React from 'react'
import { FEATURE_UC_IN_WEBREGISTER_LINE_ITEM } from '../../../../../../constants'
import { getFeatureFromCache } from '../../../../../../util/feature-cache'
import { FormButtonOnEmptyShippingAddress as FormButtonOnEmptyShippingAddressUnified } from './FormButtonOnEmptyShippingAddress'
import { FormButtonOnEmptyShippingAddressLegacy } from './FormButtonOnEmptyShippingAddressLegacy'
import type { FormButtonOnEmptyShippingAddressProps } from './useFormButtonOnEmptyShippingAddressModel'

export type { FormButtonOnEmptyShippingAddressProps } from './useFormButtonOnEmptyShippingAddressModel'

export const FormButtonOnEmptyShippingAddress: React.FC<FormButtonOnEmptyShippingAddressProps> = props => {
  const isUnifiedFulfilmentUiEnabled = getFeatureFromCache(
    FEATURE_UC_IN_WEBREGISTER_LINE_ITEM
  )

  return isUnifiedFulfilmentUiEnabled ? (
    <FormButtonOnEmptyShippingAddressUnified {...props} />
  ) : (
    <FormButtonOnEmptyShippingAddressLegacy {...props} />
  )
}
